module.exports = __webpack_public_path__ + "static/media/reviseAlert.7f5f930f.png";